import { fromJS, List } from 'immutable';

import * as _ from 'lodash';

import { SUCCESS, START, ERROR } from '@modules/appraisal/actions/global';
import * as strataActions from '../actions/strata';

import { fetchingState } from '@constants';

const initialState = {
  configurations: { data: [], state: null },
  stateCodes: { data: [], state: null },
  runs: { data: [], state: null },
};

export default (state = fromJS(initialState), action) => {
  switch (action.type) {
    case strataActions.DELETE_STRATA_RUN[SUCCESS]:
      return state.setIn(
        ['runs', 'data'],
        fromJS(
          state
            .getIn(['runs', 'data'], List([]))
            .toJS()
            .filter(b => b.runID !== action.runID),
        ),
      );
    case strataActions.FETCH_STRATA_CONFIGURATIONS[START]:
      return state.setIn(['configurations', 'state'], fetchingState.FETCHING);
    case strataActions.FETCH_STRATA_CONFIGURATIONS[SUCCESS]:
      return state
        .setIn(['configurations', 'state'], fetchingState.LOADED)
        .setIn(
          ['configurations', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    case strataActions.FETCH_STRATA_CONFIGURATIONS[ERROR]:
      return state.setIn(['configurations', 'state'], fetchingState.ERROR);

    case strataActions.FETCH_STRATA_STATE_CODES[START]:
      return state.setIn(['stateCodes', 'state'], fetchingState.FETCHING);
    case strataActions.FETCH_STRATA_STATE_CODES[SUCCESS]:
      return state
        .setIn(['stateCodes', 'state'], fetchingState.LOADED)
        .setIn(
          ['stateCodes', 'data'],
          fromJS(_.get(action, 'data.results', [])),
        );
    case strataActions.FETCH_STRATA_STATE_CODES[ERROR]:
      return state.setIn(['stateCodes', 'state'], fetchingState.ERROR);

    case strataActions.FETCH_STRATA_RUNS[START]:
      return state.setIn(['runs', 'state'], fetchingState.FETCHING);
    case strataActions.FETCH_STRATA_RUNS[SUCCESS]:
      return state
        .setIn(['runs', 'state'], fetchingState.LOADED)
        .setIn(['runs', 'data'], fromJS(_.get(action, 'data.results', [])));
    case strataActions.FETCH_STRATA_RUNS[ERROR]:
      return state.setIn(['runs', 'state'], fetchingState.ERROR);

    default:
      return state;
  }
};
